import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AdminHeader from "../components/AdminHeader";
import styles from "../styles/AdminLayout.module.css";

interface User {
  id: number;
  username: string;
  email: string;
  isAdmin: boolean;
}

const AdminLayout: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_BASE_URL!;

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch(`${API_URL}/auth/session`, {
          credentials: "include",
        });

        if (!res.ok) throw new Error("Failed to fetch session");

        const data = await res.json();

        if (!data.user || !data.user.isAdmin) {
          navigate("/login");
          return;
        }

        setUser(data.user);
      } catch (err) {
        console.error("Error checking session:", err);
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, [API_URL, navigate]);

  if (loading) return <div className={styles.loading}>Loading...</div>;
  if (!user) return null;

  return (
    <div className={styles.adminLayout}>
      {/* Sidebar + Header */}
      <aside className={styles.sidebar}>
        <AdminHeader user={user} apiUrl={API_URL} />
      </aside>

      {/* Main content */}
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
